import { createRootRoute, Outlet, useLocation } from "@tanstack/react-router";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { Toaster } from "@/components/ui/toaster";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import SiteHeader from "@/components/layout/SiteHeader";
import { useAuth } from "@/hooks/use-auth";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const location = useLocation();
  const { user } = useAuth();
  const isAuthRoute =
    location.pathname === "/login" || location.pathname.startsWith("/auth");

  if (isAuthRoute) {
    return (
      <>
        <Header />
        <Outlet />
        <Toaster />
        {/* <TanStackRouterDevtools /> */}
      </>
    );
  }

  // Check if current route is a dashboard route
  const isDashboardRoute =
    location.pathname.startsWith("/dashboard") ||
    location.pathname === "/" ||
    !!user;

  // Dashboard routes: Use DashboardLayout directly (it has its own complete layout)
  if (isDashboardRoute) {
    return (
      <>
        <SiteHeader />
        <DashboardLayout>
          <Outlet />
        </DashboardLayout>
        <Toaster />
        {/* <TanStackRouterDevtools /> */}
      </>
    );
  }

  // Non-dashboard routes: Use Header + Footer layout
  return (
    <>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
      <Toaster />
      {/* <TanStackRouterDevtools /> */}
    </>
  );
}
